import request from '@/utils/request'
// 商品一级分类列表
export function goodsclassOne() { 
  return request({
    url: '/product/goodsclass/one',
    method: 'get'
  })
}

// 商品二级分类列表
export function goodsclassTwo(id) {
  return request({
    url: '/product/goodsclass/' + id,
    method: 'get'
  })
}

// 新增商品分类
export function goodsclassSave(data) {
  return request({
    url: '/product/goodsclass/save',
    method: 'post',
    data
  })
}

// 查询所有商品分类，不分页-商品分类
export function queryGoodsClassList(data) {
  return request({
    url: `/product/goodsclass/queryGoodsClassList`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  })
}

// 根据id删除单条数据-商品分类
export function deleteOne(data) {
  return request({
    url: `/product/goodsclass/deleteOne`,
    method: 'get',
    params:data
  })
}


// 通过主键查询单条数据-商品分类
export function queryClassList(data) {
  return request({
    url: `/product/goodsclass/queryClass`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  })
}

// 通过主键查询单条数据-商品分类
export function goodsclassSelectOne(id) {
  return request({
    url: `/product/goodsclass/selectOne/${id}`,
    method: 'get'
  })
}

// 编辑商品分类
export function goodsclassEdit(data) {
  return request({
    url: `/product/goodsclass/edit`,
    method: 'put',
    data
  })
}

// 新增数据-经营范围
export function compBusinessScopeAdd(data) {
  return request({
    url: `/product/compBusinessScope/add`,
    method: 'post',
    data
  })
}

// 通过主键查询单条数据-经营范围
export function compBusinessScopeQuery(id) {
  return request({
    url: `/product/compBusinessScope/${id}`,
    method: 'get'
  })
}

// 修改数据-经营范围
export function compBusinessScopeUpdate(data) {
  return request({
    url: `/product/compBusinessScope/update`,
    method: 'put',
    data
  })
}

// 根据id删除单条数据-经营范围
export function compBusinessScopeDeleteOne(data) {
  return request({
    url: `/product/compBusinessScope/deleteOne`,
    method: 'get',
    params:data
  })
}

// 查询所有经营数据，不分页-经营范围
export function queryScopeList() {
  return request({
    url: `/product/compBusinessScope/queryScopeList`,
    method: 'post'
  })
}

// 删除类型属性-商品类型属性
export function compgoodsattributeDelete(data) {
  return request({
    url: `/product/compgoodsattribute/delete`,
    method: 'get',
    params:data
  })
}

// 根据类型id查询属性-商品类型属性
export function getAttributeByTypeId(data) {
  return request({
    url: `/product/compgoodsattribute/getAttributeByTypeId`,
    method: 'get',
    params:data
  })
}

// 保存类型属性-商品类型属性
export function compgoodsattributeSave(data) {
  return request({
    url: `/product/compgoodsattribute/save`,
    method: 'post',
    data
  })
}

// 保存类型属性-商品类型属性
export function compgoodsattributeUpdate(data) {
  return request({
    url: `/product/compgoodsattribute/update`,
    method: 'post',
    data
  })
}

// 修改-商品类型
export function compgoodstypeUpdate(data) {
  return request({
    url: `/product/compgoodstype/update`,
    method: 'post',
    data
  })
}

// 保存-商品类型
export function compgoodstypeSave(data) {
  return request({
    url: `/product/compgoodstype/save`,
    method: 'post',
    data
  })
}

// 查询商品类型-商品类型
export function getGoodsType() {
  return request({
    url: `/product/compgoodstype/getGoodsType`,
    method: 'GET'
  })
}

// 删除-商品类型
export function compgoodstypeDelete(data) {
  return request({
    url: `/product/compgoodstype/delete`,
    method: 'GET',
    params: data
  })
}
